import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { ClosedBeta } from './views/ClosedBeta';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<ClosedBeta />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.ClosedBeta)
	.build();

export default Layout;
